// removed by extract-text-webpack-plugin
module.exports = {"root":"home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","grid-container":"home--grid-container--3c3JLjRI","gridContainer":"home--grid-container--3c3JLjRI","message":"home--message--9FSspPIv"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/cl-dealer/home/styles.css
// module id = ./views/refunds/cl-dealer/home/styles.css
// module chunks = 0